import Phaser from 'phaser';
import gameData from '../gameData';
import LevelSelectButton from './LevelSelectButton';
import ABCyaPhaser from '@abcya/abcya_phaser';

export default class LevelSelectMenuPage extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   * @param {number} startIndex
   */
  constructor(scene, startIndex) {
    super(scene);

    this.inputReady = null;

    this.pageStartIndex = startIndex;

    /** @type {LevelSelectButton[]} */
    this.pageBtns = [];

    let i = this.pageStartIndex;
    const allLevels = gameData.gameConfigs[gameData.game].destinationData;
    while (i < this.pageStartIndex + 6 && i < allLevels.length) {
      const btnData = allLevels[i];
      btnData.levelId = i + 1;
      const btn = new LevelSelectButton(this.scene, btnData);
      this.add(btn);
      this.pageBtns.push(btn);
      i++;
    }

    // layout buttons
    this.layoutButtons();
  }

  layoutButtons () {
    let i = 0;
    while (i < this.pageBtns.length) {
      const btn = this.pageBtns[i];
      btn.x = i % 2 === 0 ? this.scene.scale.width / 4 : (this.scene.scale.width / 4) * 3;
      btn.y = (btn.bg.height * 1.75) * Math.floor(i / 2) + btn.bg.height;
      i++;
    }
  }

  initPageButtons () {
    let i = 0;
    while (i < this.pageBtns.length) {
      const btn = this.pageBtns[i];
      btn.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN,() => this.handleBtnSelect(btn.btnId));
      i++;
    }
  }

  deinitPageButtons () {
    let i = 0;
    while (i < this.pageBtns.length) {
      const btn = this.pageBtns[i];
      btn.off(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN);
      i++;
    }
  }

  handleBtnSelect (btnId) {
    if (this.inputReady) {
      ABCyaPhaser.Audio.playOneShot('button-click', this.scene, 1, false, 0, gameData.gameModeSoundAtlas);
      this.emit('BTN_SELECT', { _btnId: btnId });
    }
  }
}